import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { CompanyAccount } from "model";

/**
* @class ACHBatch
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.achBatchs[0];
* const contactInfo = new ACHBatch(record);
* @property {NUMBER} _id - The id of the ACHBatch.
*/
export default class ACHBatch extends BCMSRecord {
    _id
    _scheduleType
    _name
    _referenceNumber
    _secCode
    _transactionType
    _companyEntryDescription
    _company
    _creditAmount
    _debitAmount
    _status
    _pendingApprovals
    _effectiveDate

    constructor (record){     
      super(record) 
    }

    /**    
    * @function getSelectedSecCodeByBranding   
    * @static
    * @property { OBJECT } - The branding object.
    * @description Returns a selected secCode for captures, 
    * since "CCD Credit - Non-Consumer Credit" can be removed through branding options.
    * @example  const secCode = ACHBatch.getSelectedSecCodeByBranding();
    * @memberof ACHBatch 
    */
    static getSelectedSecCodeByBranding(branding) {
      const { options } = branding ?? this._GlobalController.state.branding;
      const hasACHNonConsumer = options.nonconsumer_credit_abi22 === "true";
      const secCode = hasACHNonConsumer ? "CCD Credit - Non-Consumer Credit" : "PPD Credit - Consumer Credit";
      return secCode;
    }
  }

  ACHBatch.define({
    "recordType": "achBatches",
    "recordIDProp": "id",
    "className" : "ACHBatch",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
      BCMSRecordProperty.mapToNumber("id","_id"),

        /** 
       * @name scheduleType
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("scheduleType","_scheduleType"),

        /** 
       * @name name
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("name","_name"),

        /** 
       * @name referenceNumber
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("referenceNumber","_referenceNumber"),

        /** 
       * @name secCode
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("secCode","_secCode"),

        /** 
       * @name transactionType
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("transactionType","_transactionType"),

      /** 
       * @name companyEntryDescription
       * @instance
       * @property get {STRING} - gets the companyEntryDescription value
       * @property set {STRING} - sets the companyEntryDescription value
       * @memberof ACHBatch
       */
      BCMSRecordProperty.mapToString("companyEntryDescription","_companyEntryDescription"),

        /** 
       * @name company
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToClass("company","_company", () => CompanyAccount),

        /** 
       * @name creditAmount
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToCurrency("creditAmount","_creditAmount"),

        /** 
       * @name debitAmount
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToCurrency("debitAmount","_debitAmount"),

        /** 
       * @name status
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("status","_status"),

        /** 
       * @name pendingApprovals
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToString("pendingApprovals","_pendingApprovals"),

        /** 
       * @name effectiveDate
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHBatch
       */
        BCMSRecordProperty.mapToDate("effectiveDate","_effectiveDate"),
    ]  
})




